import { render, staticRenderFns } from "./pcbk.vue?vue&type=template&id=f2ae6474&scoped=true"
import script from "./pcbk.vue?vue&type=script&lang=js"
export * from "./pcbk.vue?vue&type=script&lang=js"
import style0 from "./pcbk.vue?vue&type=style&index=0&id=f2ae6474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ae6474",
  null
  
)

export default component.exports